import { SearchTypeResponse } from 'domain/config';
import produce, { Draft } from 'immer';
import { CreditSalesInfo } from '../domain/credit-sales';
import { SaleAction, SaleDispatchObject } from './actions';

export interface SaleState {
  title: string;
  creditSaleSelected: CreditSalesInfo | null;
  searchTypes: SearchTypeResponse | null;
}

export const initialState: SaleState = {
  title: 'Pago ventas a credito',
  creditSaleSelected: null,
  searchTypes: null,
};

export const saleContextReducer = produce((draft: Draft<SaleState>, { type, payload }: SaleDispatchObject<any>) => {
  switch (type) {
    case SaleAction.ClearState:
      return initialState;

    case SaleAction.CreditSaleSelected:
      draft.creditSaleSelected = payload;
      break;

    case SaleAction.SearchTypes:
      draft.searchTypes = payload;
      break;

    default:
      throw new Error(`Unknown sale action type: ${type}`);
  }
});
